import React, { useEffect, useState } from 'react';
import { Layout } from 'antd';
import { companyAPI } from '../services/api';
import './Footer.css';

const { Footer: AntFooter } = Layout;

function Footer() {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    loadCompanyInfo();
  }, []);

  const loadCompanyInfo = async () => {
    try {
      const res = await companyAPI.getInfo();
      setCompanyInfo(res.data);
    } catch (error) {
      console.error('获取公司信息失败:', error);
    }
  };

  if (!companyInfo) return null;

  return (
    <AntFooter className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-services">
            <h3>服务内容</h3>
            <div className="service-group">
              <div className="service-column">
                <div className="service-label">个人服务</div>
                <div className="service-tags">
                  {companyInfo.services.personal.map((service, index) => (
                    <span className="service-tag" key={index}>{service}</span>
                  ))}
                </div>
              </div>
              <div className="service-column">
                <div className="service-label">企业服务</div>
                <div className="service-tags">
                  {companyInfo.services.enterprise.map((service, index) => (
                    <span className="service-tag" key={index}>{service}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="company-info">
            <p>{companyInfo.name}</p>
            <p>ICP备案：{companyInfo.icp}</p>
          </div>
          <div className="stats">
            <span>服务用户：{companyInfo.stats.users}</span>
            <span>合作企业：{companyInfo.stats.enterprises}</span>
            <span>专业咨询师：{companyInfo.stats.consultants}</span>
            <span>用户满意度：{companyInfo.stats.satisfaction}</span>
          </div>
        </div>
      </div>
    </AntFooter>
  );
}

export default Footer;
